var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var primary = {
    bg: 'primary_2',
    border: 'none',
    borderRadius: 'normal',
    boxShadow: 'button',
    color: 'neutral_0',
    fontSize: 1,
    fontWeight: 1,
    lineHeight: 'normal',
    px: 3,
    py: '6px',
    '&.large': {
        fontSize: 2,
        py: '10px',
    },
    '&:hover': {
        bg: 'primary_1',
    },
    '&:disabled, &.disabled': {
        color: 'neutral_6',
        bg: 'neutral_3',
        boxShadow: 'none',
    },
};
var secondary = {
    borderRadius: 'normal',
    fontSize: 1,
    fontWeight: 1,
    lineHeight: 'normal',
    px: 3,
    py: '5px',
    '&.large': {
        fontSize: 2,
        py: '9px',
    },
    '&:hover, &.hover': {
        borderColor: 'primary_1',
        color: 'primary_1',
    },
    '&:disabled, &.disabled': {
        borderColor: 'neutral_5',
        color: 'neutral_6',
    },
};
var plain = {
    bg: 'transparent',
    border: 'none',
    color: 'neutral_0',
    fontSize: 1,
    fontWeight: 1,
    lineHeight: 'small',
    p: 0,
    '&.large': {
        fontSize: 2,
    },
};
var plainIcon = {
    bg: 'transparent',
    border: 'none',
    borderRadius: 'normal',
    color: 'neutral_6',
    fontSize: '10px',
    lineHeight: 0,
    p: 2,
    '&:hover': {
        color: 'neutral_7',
    },
    '&.active': {
        color: 'primary_1',
    },
};
var icon = {
    bg: 'transparent',
    border: 'none',
    borderRadius: 'normal',
    color: 'neutral_6',
    fontSize: '16px',
    lineHeight: 0,
    p: '12px',
    '&.active': {
        bg: 'transparent',
        color: 'primary_2',
    },
    '&:hover, &.hover': {
        bg: 'primary_2',
        color: 'neutral_0',
    },
};
export default {
    primary: primary,
    primaryDark: __assign(__assign({}, primary), { boxShadow: 'none' }),
    login: __assign(__assign({}, primary), { letterSpacing: '1.1px !important', lineHeight: '28px' }),
    secondary: __assign(__assign({}, secondary), { bg: 'neutral_0', border: '1px solid', borderColor: 'primary_2', color: 'primary_2' }),
    secondaryDashed: __assign(__assign({}, secondary), { bg: 'neutral_1', border: '1px dashed', borderColor: 'neutral_5', color: 'neutral_6' }),
    dark: {
        bg: 'neutral_8',
        borderRadius: 'normal',
        color: 'neutral_0',
        fontSize: 1,
        fontWeight: 1,
        lineHeight: 'normal',
        px: 3,
        py: '6px',
        '&.large': {
            fontSize: 2,
            py: '10px',
        },
    },
    inverse: {
        bg: 'transparent',
        border: '1px solid',
        borderColor: 'neutral_0',
        borderRadius: 'normal',
        color: 'neutral_0',
        fontSize: 1,
        fontWeight: 1,
        lineHeight: 'normal',
        px: 3,
        py: '6px',
        '&.large': {
            fontSize: 2,
            py: '10px',
        },
    },
    plain: plain,
    plainDropdown: __assign(__assign({}, plain), { color: 'neutral_8', '&:disabled, &.disabled': {
            color: 'neutral_6',
        } }),
    icon: icon,
    iconInverse: __assign(__assign({}, icon), { color: 'neutral_0', '&:hover, &.hover': __assign(__assign({}, icon['&:hover, &.hover']), { color: 'primary_1', bg: 'neutral_0' }) }),
    headerIcon: {
        bg: 'neutral_0',
        border: 'none',
        borderRadius: 0,
        color: 'neutral_6',
        fontSize: '16px',
        lineHeight: 0,
        p: '28px',
        '&.active': {
            bg: 'primary_2',
            color: 'neutral_0',
        },
        '&:hover, &.hover': {
            '&.active': {
                bg: 'primary_1',
                color: 'neutral_0',
            },
            bg: 'neutral_1',
            color: 'neutral_6',
        },
    },
    secondaryHeaderIcon: {
        bg: 'neutral_0',
        border: 'none',
        borderRadius: 0,
        width: '56px',
        height: '56px',
        color: 'neutral_6',
        fontSize: '12px',
        lineHeight: 0,
        '&:hover, &.hover': {
            color: 'primary_2',
        },
        '&.active': {
            bg: 'primary_1',
            color: 'neutral_0',
        },
    },
    plainIcon: plainIcon,
    plainIconDark: __assign(__assign({}, plainIcon), { '&:hover, &.hover': __assign(__assign({}, plainIcon['&:hover']), { color: 'neutral_1' }) }),
    barIcon: {
        bg: 'transparent',
        border: 'none',
        borderRadius: 0,
        color: 'primary_2',
        fontSize: '16px',
        lineHeight: 0,
        p: '24px',
        '&.active': {
            bg: 'primary_2',
            color: 'neutral_0',
        },
        '&:hover, &.hover': {
            '&.active': {
                bg: 'primary_1',
                color: 'neutral_0',
            },
            bg: 'neutral_1',
            color: 'primary_1',
        },
    },
    onboardingIcon: __assign(__assign({}, primary), { bg: 'neutral_0', color: 'primary_2', padding: 0, border: '1px solid', borderColor: 'primary_4', borderRadius: 50, fontSize: '20px', width: '48px', height: '48px', '&:hover, &.hover': {
            bg: 'neutral_1',
            color: 'neutral_7',
        }, '&.active': {
            color: 'primary_1',
        } }),
    smallLink: __assign(__assign({}, plain), { color: 'primary_2', fontSize: '11px', lineHeight: '12px', fontWeight: 400 }),
};
